// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14f07ca5","239":"f4d2929f","732":"56042e77","762":"524da62f"}[chunkId] + ".chunk.js";
};